import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { Customer_ContractualAccounts } from "data/endpoints";
import DataQuery from "data/DataQuery";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { useQuery } from "data/hooks/useQuery";
import { getContractualAccountsParams } from "features/shared/helpers/queryParams";
import PagedDataResultDTO from "features/shared/dtos/PagedDataResultDTO";
import ContractualAccountDTO from "features/contracts/dtos/ContractualAccountDTO";
import ContractualAccountSelect from "features/contracts/components/ContractualAccountSelect";
import {
  getSelectFieldOptions,
  getSelectFieldOptionKey,
  getTranslatedText,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import { useTranslation } from "react-i18next";

const ContractualAccountSelectField = ({
  descriptor,
  formHandler,
}: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // form hook props
  const { bindReactSelectField, errors } = { ...formHandler };

  // helpers
  const getSearchParams = () => {
    let paginationParams = getContractualAccountsParams();
    let descriptorParams = descriptor.options?.queryString
      ? new URLSearchParams(descriptor.options?.queryString)
      : new URLSearchParams();

    return new URLSearchParams([
      ...paginationParams.entries(),
      ...descriptorParams.entries(),
    ]);
  };

  // fetch data
  let accountsQuery: DataQuery = {
    url: Customer_ContractualAccounts,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: getSearchParams(),
  };
  const { data: contractualAccounts } = useQuery<
    PagedDataResultDTO<ContractualAccountDTO>
  >(
    accountsQuery,
    { count: 0, result: [] },
    [],
    { useTracker: true },
    { apply: true, condition: () => descriptor.options?.source === "fetch" }
  );

  // render
  return (
    <div className={descriptor.className}>
      <ContractualAccountSelect
        contractualAccounts={getSelectFieldOptions(
          descriptor,
          contractualAccounts.result
        )}
        label={getTranslatedText(descriptor, "label", t)}
        placeholder={getTranslatedText(descriptor, "placeholder", t)}
        {...bindReactSelectField(
          descriptor.name,
          getSelectFieldOptionKey(
            descriptor.options?.optionValue,
            "contractualAccountId"
          )
        )}
        errors={errors}
      />
    </div>
  );
};

export default ContractualAccountSelectField;
